export enum Perfis {
  Analista = 'Analista',
  Cliente = 'Cliente',
  Administrador = 'Administrador',
}
